import { Helmet } from "react-helmet";

import ContactImage from "../assets/images/contact.svg";

import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <main>
      <Helmet>
        <title>Contact Us | Provido</title>
        <meta property="og:title" content="Contact Us | Provido" />
        <meta
          name="description"
          content="Learn how you can get in touch with our team."
        ></meta>
        <meta property="og:url" content="https://provido.com.au/contact" />
        <meta name="twitter:title" content="Contact Us | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] pt-12">
        <div className="mx-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:mx-24 lg:gap-24">
          <div className="order-2 col-span-1 md:order-1">
            <img
              src={ContactImage}
              className="-mt-6 -mb-22.5 max-h-96 w-full"
              alt="Illustration: a woman smiling and pointing downward."
            />
          </div>
          <div className="order-1 flex flex-col items-center justify-center pb-12 md:order-2">
            <h1 className="text-center font-display text-6xl leading-18 text-blue">
              Contact Us
            </h1>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-8 py-24">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
          <div className="flex flex-col gap-6">
            <div>
              <h2 className="pb-2 font-display text-2xl text-blue">
                General Enquiries
              </h2>
              <p className="text-sm">
                For all general enquiries or if you have any questions or
                concerns about our services.
              </p>
              <ul className="text-list-nodisc">
                <li>
                  <strong>Call: </strong>
                  <a href="tel:0348319551" className="text-link">
                    03 4831 9551
                  </a>
                </li>
                <li>
                  <strong>Email: </strong>
                  <a href="mailto:contact@provido.com.au" className="text-link">
                    contact@provido.com.au
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </main>
  );
};

export default Contact;
